import React, { useEffect, useState, useRef } from "react";
import OTPInput from "react-otp-input";
import axios from "axios";
import { API_URLS } from "./../../urls";
import { useLocation, useNavigate } from "react-router-dom";
import { IoReturnDownBackOutline } from "react-icons/io5";
import Cookies from "js-cookie";

export default function OTP() {
  const [phoneNumber, setPhoneNumber] = useState("");
  const [otp, setOtp] = useState("");
  const inputRefs = useRef([]);
  const [errorMessage, setErrorMessage] = useState("");
  const isButtonDisabled = otp.length !== 5;
  const [isLoading, setIsLoading] = useState(false);
  const [timer, setTimer] = useState(119);
  const location = useLocation();
  const navigate = useNavigate();

  const queryParams = new URLSearchParams(location.search);
  const origin = queryParams.get("origin");

  useEffect(() => {
    const otpRequested = localStorage.getItem("otpRequested");

    if (!otpRequested) {
      navigate("/forget_password");
    }
  }, [navigate]);
  const goBack = () => {
    navigate(-1);
  };
  useEffect(() => {
    const storedPhoneNumber = localStorage.getItem("phone_number");
    if (storedPhoneNumber) {
      setPhoneNumber(storedPhoneNumber);
    }
  }, []);

  useEffect(() => {
    if (timer > 0) {
      const interval = setInterval(() => {
        setTimer((prev) => prev - 1);
      }, 1000);
      return () => clearInterval(interval);
    }
  }, [timer]);

  const formatTime = (seconds) => {
    const minutes = Math.floor(seconds / 60);
    const remainingSeconds = seconds % 60;
    return `${minutes}:${remainingSeconds < 10 ? "0" : ""}${remainingSeconds}`;
  };

  // const handleChange = (index, value) => {
  //     if (!/^\d?$/.test(value)) return;
  //     let newOtp = [...otp];
  //     newOtp[index] = value;
  //     setOtp(newOtp);
  //     if (value && index < 4) {
  //         inputRefs.current[index + 1].focus();
  //     }
  // };

  const handleKeyDown = (index, e) => {
    if (e.key === "Backspace" && !otp[index] && index > 0) {
      inputRefs.current[index - 1].focus();
    } else if (e.key === "ArrowLeft" && index < 4) {
      inputRefs.current[index + 1].focus();
    } else if (e.key === "ArrowRight" && index > 0) {
      inputRefs.current[index - 1].focus();
    }
  };

  const handleSubmit = () => {
    localStorage.setItem("changePass", "true");

    if (otp.length === 5) {
      setIsLoading(true);
      let data = JSON.stringify({
        phone_number: phoneNumber,
        verification_code: otp,
      });

      let config = {
        method: "post",
        url: `${API_URLS.BASE_URL}auth/login_by_number`,
        headers: {
          "Content-Type": "application/json",
        },
        data: data,
      };

      axios
        .request(config)
        .then((response) => {
          if (response.data.access_token) {
            localStorage.setItem("access_token", response.data.access_token);
          }

          if (response.data.refresh_token) {
            localStorage.setItem("refresh_token", response.data.refresh_token);
          }
          setIsLoading(false);
          if (origin === "password") {
            window.location.href = "/change_password";
          } else if (origin === "login") {
            const accessToken = response.data.access_token;
            const refreshToken = response.data.refresh_token;

            Cookies.set("access_token", accessToken, { expires: 1 });
            Cookies.set("refresh_token", refreshToken, { expires: 1 });
            Cookies.set("login_time", Date.now().toString());

            window.location.href = "/";
          } else {
            window.location.href = "/verify";
          }
        })
        .catch((error) => {
          setIsLoading(false);
          setErrorMessage(
            "ارسال کد تایید با مشکل مواجه شد. لطفا دوباره تلاش کنید."
          );
          console.log("Error:", error);
        });
    }
  };

  return (
    <div className='flex bg-[#F3F5F6] w-full flex-col-reverse md:flex-row'>
      <div className='flex flex-col w-full lg:w-1/2 justify-center items-center'>
        <img src='images/logo-bime.svg' alt='' className='my-5 ' />
        <div className='w-[100%] flex flex-col items-center justify-center text-center rounded-lg py-6'>
          <p className='text-center mb-6 text-[#055187] text-[24px]'>
            {origin === "password"
              ? "فراموشی رمز عبور"
              : "ورود با کد یکبار مصرف"}
          </p>

          <p className='text-[#055187] text-[14px]'>
            کد ارسال شده به شماره {phoneNumber} را وارد کنید
          </p>
          <div
            className='w-full flex items-center justify-around text-center my-4'
            dir='ltr'
          >
            <OTPInput
              value={otp}
              onChange={(value) => {
                if (/^\d*$/.test(value)) {
                  setOtp(value);
                }
              }}
              numInputs={5}
              isInputNum={true}
              shouldAutoFocus={true}
              containerStyle={{ direction: "ltr" }}
              inputStyle={{
                width: "3rem",
                height: "3rem",
                margin: "0 10px",
                fontSize: "1.5rem",
                textAlign: "center",
                border: "1px solid #0A98ED",
                borderRadius: "16px",
                direction: "ltr",
              }}
              renderInput={(props) => <input {...props} />}
              onKeyDown={(e) => e.key === "Enter" && handleSubmit(e)}
            />
          </div>

          {errorMessage && (
            <p className='flex items-center py-2 pr-3 mt-1 w-[85%] border border-solid border-red-700 rounded-lg text-[#ff1942] bg-[#ffedf1]'>
              {errorMessage}
            </p>
          )}

          <div className='w-[85%] flex flex-col justify-center'>
            {/* نمایش تایمر */}
            {timer > 0 ? (
              <p className='text-[#055187] mb-4'>
                {formatTime(timer)} ثانیه تا ارسال مجدد کد
              </p>
            ) : (
              <button
                className='text-[#02bfe7] mb-4 '
                onClick={() => setTimer(119)}
              >
                ارسال مجدد کد
              </button>
            )}
            <button
              type='submit'
              disabled={isButtonDisabled || isLoading}
              onClick={handleSubmit}
              onKeyDown={(e) => e.key === "Enter" && handleSubmit(e)}
              className={`w-full ${
                isButtonDisabled
                  ? "bg-gray-400 cursor-not-allowed"
                  : "bg-[#02bfe7]"
              }
        text-white rounded-[40px] border-none py-3 mt-1 flex items-center justify-center
        ${isLoading ? "cursor-not-allowed" : "cursor-pointer"}`}
            >
              {isLoading ? (
                <div className='w-full h-5 animate-bounce'>تایید</div>
              ) : (
                <p>تایید</p>
              )}
            </button>
          </div>
        </div>
      </div>
      <div
        className='flex cursor-pointer items-start mt-5 pl-2'
        onClick={goBack}
      >
        <IoReturnDownBackOutline color='#055187' />
        <p className='px-3 text-[#055187]'>بازگشت</p>
      </div>
      <div
        className='w-full flex justify-center lg:w-1/2 bg-no-repeat bg-cover h-[30vh] md:h-[100vh]'
        style={{ backgroundImage: `url(images/loginPage.png)` }}
      >
        <img
          src='images/logoName.svg'
          className='w-[20%] justify-center'
          alt=''
        />
      </div>
    </div>
  );
}
